module.exports = {
  AD_BLOCK_NOTICE_DISMISSED: 'adBlockNoticeDismissed',
  COOKIE_CONSENT: 'ecosiaCookieConsent',
  EXTENSION_ACTIVE: 'ecosiaExtensionActive',

  // personal counter
  PERSONAL_COUNTER_TOOLTIP_SEARCH: 'personalCounterTooltipSearch',
  PERSONAL_COUNTER_TOOLTIP_FIRST_TREE: 'personalCounterTooltipFirstTree',
  PERSONAL_COUNTER_TOOLTIP_TREE: 'personalCounterTooltipTree',
  PERSONAL_COUNTER_CONTENT_SEARCH: 'personalCounterContentSearch',
  PERSONAL_COUNTER_CONTENT_HALF_TREE: 'personalCounterContentHalfTree',
  PERSONAL_COUNTER_CONTENT_TREE: 'personalCounterContentTree',
  PERSONAL_COUNTER_INDICATOR_SEARCH: 'personalCounterIndicatorSearch',
  PERSONAL_COUNTER_INDICATOR_HALF_TREE: 'personalCounterIndicatorHalfTree',
  PERSONAL_COUNTER_INDICATOR_FIRST_TREE: 'personalCounterIndicatorTree',

  SEARCH_SHORTCUTS_INFO_DISPLAY: 'searchShortcutInfoDisplay',
  THEME: 'nuxt-color-mode',
};
